import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <section className="notfound">
      <h1>404</h1>
      <p>Страница не найдена.</p>
      <Link to="/">На дашборд</Link>
    </section>
  );
}
